export default {"src":"/_next/static/media/plus-logo.f3da33c2.svg","height":48,"width":224,"blurWidth":0,"blurHeight":0};